(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boost-v2-countdown"] && !window.DesignMode) return;
  try {
    

// Calculate milliseconds in a year
var minute = 1000 * 60;
var hour = minute * 60;
var day = hour * 24;
var year = day * 365;
  
function timeUpdate() {
currentDate = new Date();
  
//console.log('date: ' + currentDate + ', target minus date: ' + (startDate - currentDate) );
  
daysLeft = (startDate - currentDate) / day;
days = String(daysLeft).split('.');
hours = String(Number( '0.' + days[1] ) * 24).split('.');
minutes = String( Number( '0.' + hours[1] ) * 60 ).split('.');
seconds = String(Number( '0.' + minutes[1] ) * 60).split('.');

document.querySelector("#countdown-days").innerHTML = days[0];
document.querySelector("#countdown-hours").innerHTML = hours[0];
document.querySelector("#countdown-minutes").innerHTML = minutes[0];

  if(seconds[0] < 10) {
    document.querySelector("#countdown-seconds-1").innerHTML = '0';
    document.querySelector("#countdown-seconds-2").innerHTML = seconds[0][0];
  }
  else {
    document.querySelector("#countdown-seconds-1").innerHTML = seconds[0][0];
    document.querySelector("#countdown-seconds-2").innerHTML = seconds[0][1];
  }

  if( (startDate - currentDate) < 0 ) {
    countDownHide();
    clearInterval(counDownTimer);
  }
  
}

timeUpdate();

var counDownTimer = setInterval(timeUpdate, 1000);

  } catch(e) { console.error(e); }
})();
})();
